export default "__VITE_ASSET__CJyCBxDY__"